export default {
  SET_EMPLOYEES(state, employees) {
    state.employees = employees
  },
  SET_EMPLOYEES_COUNT(state, count) {
    state.employeesCount = count
  },
  SET_EMPLOYEES_QUERY(state, query) {
    state.query = query
  },
  SET_EMPLOYEES_LIMIT(state, limit) {
    state.limit = limit
  },
  SET_EMPLOYEES_SKIP(state, skip) {
    state.skip = skip
  },
  SET_EMPLOYEES_SORT(state, sort) {
    state.sort = sort
  }
}
